
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';

@Component({
	components: { Loading },
})
export default class LoadingForecast extends Vue {}
